<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{
          form === "catalog"
            ? $t("vending.manageCatalog")
            : form === "products"
            ? $t("vending.manageProducts")
            : $t("vending.editVending")
        }}
      </p>
    </header>

    <section class="modal-card-body">
      <vending-form-general-info
        v-if="form === 'general-info'"
        @get-vendings="$emit('get-vendings')"
      />

      <vending-form-catalog
        v-else-if="form === 'catalog'"
        @get-vendings="$emit('get-vendings')"
      />

      <vending-form-products
        v-else-if="form === 'products'"
        @show-save-changes-button="showSaveChangesButton"
        @get-vendings="$emit('get-vendings')"
      />
    </section>

    <footer class="modal-card-foot">
      <div style="width: 100%;">
        <button class="button" type="button" @click="$parent.close()">
          {{ $t("common.close") }}
        </button>

        <button
          v-if="form === 'products'"
          :disabled="!saveChangesButtonVisible"
          class="button"
          :style="{
            backgroundColor: $primaryColor,
            color: $primaryColorContrast
          }"
          type="button"
          @click="saveVendingProducts"
        >
          {{ $t("common.save") }}
        </button>

        <button
          v-if="
            form === 'products' &&
              companyInfo.isCacauShowHeadquarter &&
              !vendingBeingManaged.vendingInfo.isCacauShow
          "
          class="button is-pulled-right is-info"
          style="margin-left: .5rem;"
          type="button"
          @click="forceChildrenVendingsPriceUpdate"
        >
          {{ $t("vending.forceChildrenVendingsPriceUpdate") }}
        </button>

        <button
          class="button is-pulled-right"
          @click="downloadVendingProductsReport"
        >
          <b-icon icon="save"></b-icon>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import vendingFormGeneralInfo from "./VendingFormGeneralInfo";
import vendingFormCatalog from "./VendingFormCatalog";
import vendingFormProducts from "./VendingFormProducts";

export default {
  props: ["form"],

  mixins: [common],

  components: {
    vendingFormGeneralInfo,
    vendingFormCatalog,
    vendingFormProducts
  },

  data() {
    return {
      isLoading: false,
      saveChangesButtonVisible: false
    };
  },

  methods: {
    showSaveChangesButton() {
      if (!this.saveChangesButtonVisible) {
        this.$buefy.toast.open({
          message: this.$t("vending.dontForgetToSaveChanges"),
          type: "is-primary",
          position: "is-bottom",
          duration: 5000
        });
      }
      this.saveChangesButtonVisible = true;
    },

    saveVendingProducts() {
      this.isLoading = true;
      this.$store
        .dispatch("saveVendingProducts", {
          products: this.vendingBeingManaged.products.map(p => {
            return { ...p, p: Number((p.p * 100).toFixed(0)) };
          }),
          vendingId: this.vendingBeingManaged._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("vending.productsUpdated"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
            this.$emit("update-vending");
            this.$parent.close();
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    forceChildrenVendingsPriceUpdate() {
      this.isLoading = true;
      this.$store
        .dispatch("forceChildrenVendingsPriceUpdate", {
          vendingId: this.vendingBeingManaged._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("vending.childrenUpdateRunning"),
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadVendingProductsReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadVendingProductsReport", {
          vendingId: this.vendingBeingManaged._id
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["vendingBeingManaged", "companyInfo"])
  }
};
</script>
